<template>
  <div class="page">
    <div class="title">指定单</div>
    <div class="box">
      <div v-for="(item,index) of list" :key="index">
        <div class="item-title">{{item.name}}</div>
        <div class="switch-item" :class="index2 + 1 == item.list.length ? 'last' : ''" v-for="(item2,index2) of item.list" :key="index2">
          <div>{{item2.name}}</div>
          <van-switch :value="clerkItemSwitchIds.indexOf(item2.id) != -1" active-color="var(--primary-color)"
                      inactive-color="#E6E6E6" size="24" @change="updateItemSwitch(item2.id)"/>
        </div>
      </div>
    </div>
    <div class="title">随机单</div>
    <div class="box">
      <div v-for="(item,index) of list2" :key="index">
        <div class="item-title">{{item.name}}</div>
        <div class="switch-item" :class="index2 + 1 == item.list.length ? 'last' : ''" v-for="(item2,index2) of item.list" :key="index2">
          <div>{{item2.name}}</div>
          <van-switch :value="clerkItemSwitchIds.indexOf(item2.id) != -1" active-color="var(--primary-color)"
                      inactive-color="#E6E6E6" size="24" @change="updateItemSwitch(item2.id)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Switch } from 'vant';

import {
  getItemSwitchList,
  updateItemSwitch,
} from '@/api/clerk/clerk'
import {Dialog, Toast} from "vant";
Vue.use(Switch)

export default {
  name: "skillSwitch",

  data(){
    return{
      option: this.$route.query.switch,
      list: [],
      list2: [],
      clerkItemSwitchIds: [],
    }
  },

  methods:{
    getItemSwitchList(){
      this.list = []
      getItemSwitchList().then(res=>{
        let data = res.data
        this.list = data.fixedList
        document.title = '个人主页服务技能开关'
        this.list2 = data.randomList
        this.clerkItemSwitchIds = data.clerkItemSwitchIds
      })
    },

    updateItemSwitch(switchId) {
      let switchIds = [].concat(this.clerkItemSwitchIds)
      if (switchIds.indexOf(switchId) != -1) {
        switchIds.splice(switchIds.indexOf(switchId), 1)
      } else {
        switchIds.push(switchId)
      }

      Toast.loading({
        mask: true,
        message: '请稍候'
      })
      updateItemSwitch(
        JSON.stringify(switchIds),
        switchId
      ).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.clerkItemSwitchIds = switchIds
          Toast('修改成功')
        } else {
          // this.loadData()
          Dialog.alert({
            title: '修改失败',
            message: data.msg
          })
        }
      })
    }
  },

  activated(){
    this.getItemSwitchList()
    this.option = this.$route.query.switch
  }
}
</script>

<style scoped lang="less">
.page{
  min-height: 100vh;
  background: #F4F7FA;
  padding: 0px 16px;
  .title{
    font-size: 12px;
    line-height: 12px;
    color: #81868F;
    padding: 24px 0 8px 0;
  }
  .box{
    padding: 3px 14px;
    background: #fff;
    border-radius: 12px;
    .item-title{
      padding-top: 13px;
      font-size: 15px;
      line-height: 15px;
      color: #0E151A;
    }
    .switch-item{
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 15px;
      color: #6E7376;
      border-bottom: 1px #F3F5FA solid;
    }
    .last{
      border-bottom: none;
    }
  }
  /deep/.van-switch{
    border: 2px solid rgba(0,0,0,0);
  }
}
</style>
